export default __webpack_public_path__ + "static/media/usd-coin-usdc-logo.f08e02b1.svg";